import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import {
  individualsService,
  Individual,
  SignUpIndividualRequest,
} from '@aslanpay/portal-common-lib';

const useSignUpIndividual = ({
  onSuccess,
  onError,
}: UseMutationOptions<Individual, Error, SignUpIndividualRequest>) => {
  return useMutation<Individual, Error, SignUpIndividualRequest>(
    ({ phoneNumber, signUpToken, password, firstName, lastName }: SignUpIndividualRequest) =>
      individualsService.signUpIndividual({
        phoneNumber,
        signUpToken,
        password,
        firstName,
        lastName,
      }),
    { onSuccess, onError }
  );
};

export default useSignUpIndividual;
